import { useSelector } from "react-redux";
import { setUser, setQuote, setStatus } from "../../reducers/userReducer";
import fourth from "./homeConfig";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchQuote } from "../../reducers/userReducer";
import { useEffect, useState } from "react";

export default function Homepage() {
  const [homeColor, setColor] = useState('#3AB0FF')
  const username = useSelector(setUser);
  const dispatch = useDispatch();
  const { image1, image2 } = fourth.fourth;
  useEffect(() => {
    dispatch(fetchQuote());
  }, [dispatch])
  const quote = useSelector(setQuote);
  const status = useSelector(setStatus);
  let content;
  if(status==="idle"){
    content = "Loading..."
  } else if (status === "success") {
    content = (
      <p className="card-text">
        {quote.content}
        <div><cite title="Source Title">{quote.author}</cite></div>
      </p>
    );
  } else if (status === "failed") {
    content = <p>{quote}</p>;
  }

  return (
    <div className="container p-4">
      <h3 className="text-center pt-2 pb-4">Home</h3>
      <h1 className="pb-2">
        Welcome, <span className="blue-color">{username}</span>
      </h1>
      <h5>What would you like to do today?</h5>
      <p>Don't know? Check out the features <a target='_blank' rel="noreferrer" href='https://hanchor.netlify.app'>here</a></p>
      <div className="boxes">
        <Link to="/gratitude" className="link links">
          <div className="box box1">
            <h6>Count my blessings</h6>
          </div>
        </Link>
        <Link to="/todo" className="link links">
          <div className="box box2">
            <h6>Life Planner</h6>
          </div>
        </Link>
        <Link to="/affirmIntro" className="link links">
          <div className="box box3">
            <h6>My Affirmations</h6>
          </div>
        </Link>
        <Link to="/video" className="link links">
          <div className="box box4">
            <h6>Happiness Island</h6>
          </div>
        </Link>
      </div>
      <h2 className="mt-4">Qoute of the day</h2>
      <div className="card bg-dark text-white">
        <img className="card-img" src={image1} alt="Card" />
        <div className="card-img-overlay d-flex align-items-center">
          {content}
        </div>
      </div>
      <h2 className="mt-4">Financial Intelligence Blog</h2>
      <div className="card bg-dark text-white mb-5">
        <img className="card-img" src={image2} alt="Card" />
        <div className="card-img-overlay d-flex flex-column justify-content-center">
          <h5 className="card-title">SAPA Abeg</h5>
          <p className="card-text">(How to avoid being broke)</p>
        </div>
      </div>
      <Footer homeColor={homeColor}/>
    </div>
  );
}
